import { createFileRoute } from "@tanstack/react-router";
import { PathshalasPage } from "@/projects/admin/pages/PathshalasPage";

export const Route = createFileRoute("/admin/pathshalas")({
  head: () => ({ meta: [{ title: "Pathshalas — Admin" }] }),
  component: PathshalasPage,
});
